import { propOr, trim } from 'ramda';

import { IUsersResponse, TFullRecipient, TFullSender } from './users.types';

const getFirstName = propOr('', 'firstName');
const getLastName = propOr('', 'lastName');

export const transformUsersData = ({
  recipient,
  sender,
}: IUsersResponse): { recipient: TFullRecipient; sender: TFullSender } => ({
  recipient: {
    ...recipient,
    fullName: trim(`${getFirstName(recipient)}\xa0${getLastName(recipient)}`),
  },
  sender: {
    ...sender,
    fullName: trim(`${getFirstName(sender)}\xa0${getLastName(sender)}`),
  },
});
